import React, { useEffect, useState } from "react";
import AdminSidebar from "../components/AdminSidebar";
import AdminNavbar from "../components/AdminNavbar";
import AdminAPI from "../../services/adminApi";
import { toast } from "react-toastify";

function SupportTickets() {
  const [tickets, setTickets] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);

  const [filters, setFilters] = useState({
    search: "",
    status: "",
    priority: "",
    category: ""
  });

  const [replyForm, setReplyForm] = useState({
    message: "",
    attachment: null
  });

  useEffect(() => {
    fetchTickets();
  }, []);

  const fetchTickets = async () => {
    try {
      const res = await AdminAPI.get(
        `/support?search=${filters.search}&status=${filters.status}&priority=${filters.priority}&category=${filters.category}`
      );

      setTickets(res.data);

    } catch (err) {
      console.log(err);
      toast.error("Failed to load tickets");
    }
  };

  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value
    });
  };

  const openTicket = async (id) => {
    try {
      const res = await AdminAPI.get(`/support/${id}`);

      setSelectedTicket(res.data);

      setReplyForm({
        message: "",
        attachment: null
      });

    } catch (err) {
      toast.error("Failed to load ticket");
    }
  };

  const handleReplyChange = (e) => {
    const { name, value, files } = e.target;

    setReplyForm({
      ...replyForm,
      [name]: files ? files[0] : value
    });
  };

  const sendReply = async () => {
    try {
      const formData = new FormData();

      formData.append("message", replyForm.message);

      if (replyForm.attachment) {
        formData.append(
          "attachment",
          replyForm.attachment
        );
      }

      await AdminAPI.post(
        `/support/reply/${selectedTicket.ticket.id}`,
        formData
      );

      toast.success("Reply sent");

      openTicket(selectedTicket.ticket.id);
      fetchTickets();

    } catch (err) {
      toast.error("Reply failed");
    }
  };

  const updateStatus = async (status) => {
    try {
      await AdminAPI.put(
        `/support/status/${selectedTicket.ticket.id}`,
        { status }
      );

      toast.success("Status updated");

      openTicket(selectedTicket.ticket.id);
      fetchTickets();

    } catch (err) {
      toast.error("Status update failed");
    }
  };

  const deleteTicket = async (id) => {
    const confirmDelete = window.confirm(
      "Delete this ticket?"
    );

    if (!confirmDelete) return;

    try {
      await AdminAPI.delete(`/support/${id}`);

      toast.success("Ticket deleted");

      fetchTickets();

      if (selectedTicket) {
        setSelectedTicket(null);
      }

    } catch (err) {
      toast.error("Delete failed");
    }
  };

  return (
    <div className="d-flex">
      <AdminSidebar />

      <div
        style={{
          flex: 1,
          background: "#f5f7fa",
          minHeight: "100vh",
          padding: "20px"
        }}
      >
        <AdminNavbar />

        <h2 className="mt-3">🎫 Support Management</h2>

        {/* FILTERS */}
        <div className="card shadow border-0 mt-4">
          <div className="card-body">
            <div className="d-flex gap-3 flex-wrap">
              <input
                type="text"
                name="search"
                className="form-control"
                style={{ width: "250px" }}
                placeholder="Search..."
                value={filters.search}
                onChange={handleFilterChange}
              />

              <select
                name="status"
                className="form-select"
                style={{ width: "180px" }}
                value={filters.status}
                onChange={handleFilterChange}
              >
                <option value="">All Status</option>
                <option value="open">Open</option>
                <option value="in_progress">In Progress</option>
                <option value="resolved">Resolved</option>
                <option value="closed">Closed</option>
              </select>

              <select
                name="priority"
                className="form-select"
                style={{ width: "180px" }}
                value={filters.priority}
                onChange={handleFilterChange}
              >
                <option value="">All Priority</option>
                <option value="low">Low</option>
                <option value="medium">Medium</option>
                <option value="high">High</option>
                <option value="urgent">Urgent</option>
              </select>

              <select
                name="category"
                className="form-select"
                style={{ width: "180px" }}
                value={filters.category}
                onChange={handleFilterChange}
              >
                <option value="">All Categories</option>
                <option value="technical">Technical</option>
                <option value="weather">Weather</option>
                <option value="ai">AI</option>
                <option value="photo">Photo</option>
                <option value="checklist">Checklist</option>
                <option value="cycle">Cycle</option>
                <option value="account">Account</option>
                <option value="billing">Billing</option>
                <option value="general">General</option>
                <option value="other">Other</option>
              </select>

              <button
                className="btn btn-success"
                onClick={fetchTickets}
              >
                Search
              </button>
            </div>
          </div>
        </div>

        {/* TABLE */}
        <div className="card shadow border-0 mt-4">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-success">
                  <tr>
                    <th>Farmer</th>
                    <th>Subject</th>
                    <th>Category</th>
                    <th>Priority</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {tickets.map((ticket) => (
                    <tr key={ticket.id}>
                      <td>{ticket.full_name}</td>
                      <td>{ticket.subject}</td>
                      <td>{ticket.category}</td>
                      <td>{ticket.priority}</td>
                      <td>{ticket.status}</td>

                      <td>
                        <button
                          className="btn btn-primary btn-sm me-2"
                          onClick={() => openTicket(ticket.id)}
                        >
                          View
                        </button>

                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() =>
                            deleteTicket(ticket.id)
                          }
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>

              </table>
            </div>
          </div>
        </div>

        {/* MODAL */}
        {selectedTicket && (
          <div
            className="modal d-block"
            style={{
              background: "rgba(0,0,0,0.6)"
            }}
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">

                <div className="modal-header">
                  <h5>
                    {selectedTicket.ticket.subject}
                  </h5>

                  <button
                    className="btn-close"
                    onClick={() =>
                      setSelectedTicket(null)
                    }
                  />
                </div>

                <div className="modal-body">
                  <p>
                    <strong>Farmer:</strong>{" "}
                    {selectedTicket.ticket.full_name}
                  </p>

                  <p>
                    {selectedTicket.ticket.description}
                  </p>

                  <hr />

                  <h6>Conversation</h6>

                  {selectedTicket.replies.map((reply) => (
                    <div
                      key={reply.id}
                      className={`p-3 rounded mb-2 ${
                        reply.sender_type === "admin"
                          ? "bg-success text-white"
                          : "bg-light"
                      }`}
                    >
                      <strong>
                        {reply.sender_type}
                      </strong>

                      <p className="mb-0">
                        {reply.message}
                      </p>
                    </div>
                  ))}

                  <hr />

                  <textarea
                    className="form-control"
                    rows="3"
                    name="message"
                    placeholder="Reply..."
                    value={replyForm.message}
                    onChange={handleReplyChange}
                  />

                  <input
                    type="file"
                    name="attachment"
                    className="form-control mt-2"
                    onChange={handleReplyChange}
                  />

                  <button
                    className="btn btn-success mt-3"
                    onClick={sendReply}
                  >
                    Send Reply
                  </button>

                  <hr />

                  <div className="d-flex gap-2 flex-wrap">
                    <button
                      className="btn btn-warning"
                      onClick={() =>
                        updateStatus("in_progress")
                      }
                    >
                      In Progress
                    </button>

                    <button
                      className="btn btn-success"
                      onClick={() =>
                        updateStatus("resolved")
                      }
                    >
                      Resolve
                    </button>

                    <button
                      className="btn btn-secondary"
                      onClick={() =>
                        updateStatus("closed")
                      }
                    >
                      Close
                    </button>
                  </div>

                </div>

              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

export default SupportTickets;